'use client'

import { useTranslations } from 'next-intl'
import { useWatch } from 'react-hook-form'

import { cn, isEmptyString } from '@/shared/lib'
import { Form } from '@/shared/ui'

import { formatTime } from '../../lib/timer'

type Props = {
  timeLeft: number
}

export const CertCodeField = ({ timeLeft }: Props) => {
  const t = useTranslations('email_verification')

  const certCode = useWatch({ name: 'certCode' })

  return (
    <Form.Field name="certCode">
      <Form.Label bold>{t('code.label')}</Form.Label>
      <div className="relative">
        <Form.TextField
          placeholder={t('code.placeholder')}
          fullWidth
          className="gap-12"
        />
        {timeLeft > 0 && (
          <span
            className={cn(
              'typo-label1 pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-purple-500',
              {
                'right-9': !isEmptyString(certCode),
              },
            )}
          >
            {formatTime(timeLeft)}
          </span>
        )}
      </div>
      <Form.Message />
    </Form.Field>
  )
}
